"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orExpression = exports.andExpression = exports.complexExpression = exports.simpleExpression = exports.emptyExpression = void 0;
/* eslint-disable no-plusplus */
const templates_1 = require("./templates");
let i = 0;
const uuid = () => `mockid-${i++}`;
exports.emptyExpression = (0, templates_1.defaultExpression)();
exports.simpleExpression = {
    type: 'expression',
    operator: 'equals',
    id: uuid(),
    left: {
        type: 'variable',
        stepId: '0',
        variableId: uuid(),
    },
    right: {
        type: 'constant',
        value: 'Something else',
        valueType: 'string',
    },
};
exports.complexExpression = {
    type: 'expression',
    operator: 'or',
    id: uuid(),
    operands: [
        {
            type: 'expression',
            operator: 'and',
            id: uuid(),
            operands: [
                {
                    type: 'expression',
                    operator: 'equals',
                    id: uuid(),
                    left: {
                        type: 'variable',
                        stepId: '0',
                        variableId: uuid(),
                    },
                    right: {
                        type: 'constant',
                        value: 'Something else',
                        valueType: 'string',
                    },
                },
                {
                    type: 'expression',
                    operator: 'equals',
                    id: uuid(),
                    left: {
                        type: 'variable',
                        stepId: '0',
                        variableId: uuid(),
                    },
                    right: {
                        type: 'constant',
                        value: 'Something else',
                        valueType: 'string',
                    },
                },
            ],
        },
        {
            type: 'expression',
            operator: 'and',
            id: uuid(),
            operands: [
                {
                    type: 'expression',
                    operator: 'equals',
                    id: uuid(),
                    left: {
                        type: 'variable',
                        stepId: '0',
                        variableId: uuid(),
                    },
                    right: {
                        type: 'constant',
                        value: 'Something else',
                        valueType: 'string',
                    },
                },
                {
                    type: 'expression',
                    operator: 'equals',
                    id: uuid(),
                    left: {
                        type: 'variable',
                        stepId: '0',
                        variableId: uuid(),
                    },
                    right: {
                        type: 'constant',
                        value: 'Something else',
                        valueType: 'string',
                    },
                },
                {
                    type: 'expression',
                    operator: 'equals',
                    id: uuid(),
                    left: {
                        type: 'variable',
                        stepId: '0',
                        variableId: uuid(),
                    },
                    right: {
                        type: 'constant',
                        value: 'Something else',
                        valueType: 'string',
                    },
                },
            ],
        },
        {
            type: 'expression',
            operator: 'equals',
            id: uuid(),
            left: {
                type: 'variable',
                stepId: '0',
                variableId: uuid(),
            },
            right: {
                type: 'constant',
                value: 'Something else',
                valueType: 'string',
            },
        },
    ],
};
exports.andExpression = {
    operator: 'and',
    id: uuid(),
    operands: [
        {
            type: 'expression',
            operator: 'equals',
            id: uuid(),
            left: {
                type: 'variable',
                stepId: '0',
                variableId: uuid(),
            },
            right: {
                type: 'constant',
                value: 'Something else',
                valueType: 'string',
            },
        },
        {
            type: 'expression',
            operator: 'equals',
            id: uuid(),
            left: {
                type: 'variable',
                stepId: '0',
                variableId: uuid(),
            },
            right: {
                type: 'constant',
                value: 'Something else',
                valueType: 'string',
            },
        },
    ],
};
exports.orExpression = {
    operator: 'or',
    id: uuid(),
    operands: [
        {
            type: 'expression',
            operator: 'equals',
            id: uuid(),
            left: {
                type: 'variable',
                stepId: '0',
                variableId: uuid(),
            },
            right: {
                type: 'constant',
                value: 'Something else',
                valueType: 'string',
            },
        },
        {
            type: 'expression',
            operator: 'equals',
            id: uuid(),
            left: {
                type: 'variable',
                stepId: '0',
                variableId: uuid(),
            },
            right: {
                type: 'constant',
                value: 'Something else',
                valueType: 'string',
            },
        },
    ],
};
//# sourceMappingURL=Expression.mock.js.map